(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection-fincut"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const filterContainer = document.querySelector('.fincut-filters');
  const filters = document.querySelectorAll('.fincut-filter');
  
  let startX = 0;
  let startY = 0;
  let moveX = 0;
  let moveY = 0;
  let isScrolling = false;
  let touchStartTime = 0;
  
  function handleFilterClick(button) {
    // Remove active state from all filters
    filters.forEach(btn => {
      btn.classList.remove('active');
      btn.style.background = 'none';
      btn.style.color = btn.style.getPropertyValue('--filter-text-color');
      btn.style.borderColor = btn.style.getPropertyValue('--filter-border-color');
    });
    
    // Add active state to clicked filter
    button.classList.add('active');
    button.style.background = button.style.getPropertyValue('--filter-active-bg');
    button.style.color = button.style.getPropertyValue('--filter-active-text');
    button.style.borderColor = button.style.getPropertyValue('--filter-active-bg');

    // Show/hide collections based on selection
    const selectedCollection = button.dataset.collection;
    const groups = document.querySelectorAll('.fincut-collection-group');
    
    groups.forEach(group => {
      if (selectedCollection === 'all' || group.dataset.collection === selectedCollection) {
        group.style.display = '';
      } else {
        group.style.display = 'none';
      }
    });
  }

  // Desktop click handler
  filters.forEach(button => {
    button.addEventListener('click', (e) => {
      if (!('ontouchstart' in window)) {
        handleFilterClick(button);
      }
    });
  });

  // Touch event handlers
  filterContainer.addEventListener('touchstart', (e) => {
    const touch = e.touches[0];
    startX = touch.clientX;
    startY = touch.clientY;
    moveX = 0;
    moveY = 0;
    isScrolling = false;
    touchStartTime = Date.now();
  }, { passive: true });

  filterContainer.addEventListener('touchmove', (e) => {
    if (!e.touches[0]) return;
    
    moveX = e.touches[0].clientX - startX;
    moveY = e.touches[0].clientY - startY;
    
    // Determine if user is scrolling horizontally
    if (Math.abs(moveX) > Math.abs(moveY) && Math.abs(moveX) > 10) {
      isScrolling = true;
    }
  }, { passive: true });

  filterContainer.addEventListener('touchend', (e) => {
    const touchEndTime = Date.now();
    const timeDiff = touchEndTime - touchStartTime;
    
    // If it was a quick tap (less than 200ms) and minimal movement (less than 10px)
    if (timeDiff < 200 && Math.abs(moveX) < 10 && Math.abs(moveY) < 10) {
      const target = e.target.closest('.fincut-filter');
      if (target) {
        handleFilterClick(target);
      }
    }
    
    // Reset scrolling state after a short delay
    setTimeout(() => {
      isScrolling = false;
    }, 100);
  });

  // Media query for responsive sizes
  const mediaQuery = window.matchMedia('(min-width: 768px)');
  const titles = document.querySelectorAll('.fincut-collection__title');

  function updateSizes(e) {
    titles.forEach((title, index) => {
      const block = section.blocks[index];
      if (block && block.settings) {
        title.style.fontSize = e.matches ? 
          `${block.settings.title_size_desktop}px` : 
          `${block.settings.title_size_mobile}px`;
      }
    });
  }

  mediaQuery.addListener(updateSizes);
  updateSizes(mediaQuery);
});

  } catch(e) { console.error(e); }
})();
})();
